import { render, staticRenderFns } from "./DebugInfo.vue?vue&type=template&id=2042c5f0&"
import script from "./DebugInfo.vue?vue&type=script&lang=js&"
export * from "./DebugInfo.vue?vue&type=script&lang=js&"
import style0 from "./DebugInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2042c5f0')) {
      api.createRecord('2042c5f0', component.options)
    } else {
      api.reload('2042c5f0', component.options)
    }
    module.hot.accept("./DebugInfo.vue?vue&type=template&id=2042c5f0&", function () {
      api.rerender('2042c5f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/search/components/DebugInfo.vue"
export default component.exports